import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/whatsapp-groups';

function unwrap(body) {
  if (body?.success === false) {
    const msg = body?.message;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return body?.data ?? body;
}

const whatsappGroupService = {
  list: async (params = {}) => {
    const response = await apiClient.get(BASE, { params });
    const data = unwrap(response.data);
    return {
      groups: data?.groups ?? [],
      pagination: data?.pagination ?? null,
    };
  },

  get: async (uuid) => {
    const response = await apiClient.get(`${BASE}/${uuid}`);
    const data = unwrap(response.data);
    return data?.group ?? null;
  },

  fetchWhapiCatalog: async () => {
    const response = await apiClient.get(`${BASE}/whapi-catalog`);
    const data = unwrap(response.data);
    return data?.groups ?? [];
  },

  fetchUserOptions: async (params = {}) => {
    const response = await apiClient.get(`${BASE}/user-options`, { params });
    const data = unwrap(response.data);
    return data?.users ?? [];
  },

  fetchRmOptions: async () => {
    const response = await apiClient.get(`${BASE}/rm-options`);
    const data = unwrap(response.data);
    return data?.rms ?? [];
  },

  create: async (payload) => {
    const response = await apiClient.post(BASE, payload);
    return response.data;
  },

  update: async (uuid, payload) => {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response.data;
  },

  remove: async (uuid) => {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response.data;
  },
};

export default whatsappGroupService;
